var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"badge-mode",style:({ backgroundColor: _vm.color, color: 'white' }),attrs:{"pill":""}},[_vm._v(" "+_vm._s(_vm.time)+" Due ")])
}
var staticRenderFns = []

export { render, staticRenderFns }